import React, { useEffect } from "react";
import Layout from "../../Layout";
import "./csportfolio.css";
import { Link } from "react-router-dom";

import DaisyThumb from "../../Images/Daisy.png";
import VGThumb from "../../Images/VG.png";
import StudentThumb from "../../Images/Student.png";
import TensorThumb from "../../Images/Tensor_Thumb.png";
import Portfolio_Thumb from "../../Images/Portfolio_Thumb.png";


export default function CSPortfolio() {
  useEffect(() => {
    const elements = document.querySelectorAll(".reveal");
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("show");
        }
      });
    });
    elements.forEach(el => observer.observe(el));
  }, []);

  return (
    <Layout>
      <main className="tp-page">
        <header className="tp-hero">
          <h1 className="tp-title" >My ꙳Technical꙳ Projects</h1>
          <p className="tp-sub">
            These projects tell the story of my growth as a developer— how I learned to weave my creativity and apply it to my passion for software
            and code. I care about design that makes sense, code that’s clean, 
            and solutions that actually help people. The work here represents late nights, problem-solving, trial and error,
            and the satisfaction of finally getting something to click. <b>It’s a reflection of what I value: clarity, consistency, and creating work that matters.</b>
            
          </p>
          <p className="tp-sub2">These are highlights of my favorite technical projects. More of my projects are on my GitHub.</p>
        </header>
        

        {/* 1 */}
        <section className="tp-section tp-section--light">
          
          <div className="tp-row">
            <figure className="tp-thumb reveal">
              <img src={DaisyThumb} alt="Daisy Pet Sitting & Services" className="fade-up" />
            </figure>

            <article className="tp-card reveal">
              <div className="tp-card-head">
                <h2 className="tp-card-title">Daisy Pet Sitting & Services</h2>
                <time className="tp-card-date">2025</time>
              </div>

              <p className="tp-card-desc">
               This site was built to help a small business owner present her pet-sitting services in a clean and welcoming way. 
               I designed the layout and visuals to make browsing services and booking appointments simple, clear, and stress-free for her clients.
              </p>

              <p className="tp-tools">
                Programs used: WordPress, Figma, Procreate, Adobe Photoshop & Illustrator, HTML/CSS, Canva
              </p>

              <Link to="/projects/Pet" className="tp-link"> Learn more →</Link>
            </article>
          </div>
        </section>

        {/* 2 */}
        <section className="tp-section tp-section--dark">
          <div className="tp-row tp-row--reverse">
            <figure className="tp-thumb reveal">
               <img src={VGThumb} alt="Video Game Full-Stack App" className="fade-up" />
            </figure>

            <article className="tp-card tp-card--right reveal">
              <div className="tp-card-head">
                <h2 className="tp-card-title">Video Game Full-Stack App</h2>
                <time className="tp-card-date">2024</time>
              </div>

              <p className="tp-card-desc">
                What began as a semester task to build a CRUD app became a fully functional 
                video game database. It was a fun challenge that pushed me to bring both structure and creativity into the build.
              </p>

              <p className="tp-tools">
                Programs used: Javascript, React.JS, SQL, C#, .NET, Postman, HTML/CSS, Git + GitHub
              </p>

              <Link to="/projects/vgdb" className="tp-link"> Learn more →</Link>
            </article>
          </div>
        </section>

        {/* 3 */}
        <section className="tp-section tp-section--light">
          <div className="tp-row">
            <figure className="tp-thumb reveal">
              <img src={StudentThumb} alt="Student Management System" className="fade-up" />
            </figure>

            <article className="tp-card reveal">
              <div className="tp-card-head">
                <h2 className="tp-card-title">Student Management System</h2>
                <time className="tp-card-date">2024</time>
              </div>

              <p className="tp-card-desc">
                As a team, we designed and built a Student Management System from the ground up, starting with UML diagrams and 
                moving into full implementation. Working together on structure, logic, and user flow taught me  
                collaborative planning and thinking like a software engineer.
              </p>

              <p className="tp-tools">
                Programs used: Java, JavaFX, Maven, Python, JUnit, Git + GitHub
              </p>

              <Link to="/projects/student" className="tp-link"> Learn more →</Link>
            </article>
          </div>
        </section>

        {/* 4 */}
        <section className="tp-section tp-section--dark">
          <div className="tp-row tp-row--reverse">
            <figure className="tp-thumb reveal">
              <img src={TensorThumb} alt="Digital Handwritten Model" className="fade-up" />
            </figure>

            <article className="tp-card tp-card--right reveal">
              <div className="tp-card-head">
                <h2 className="tp-card-title">Digital Handwritten Model</h2>
                <time className="tp-card-date">2024</time>
              </div>

              <p className="tp-card-desc">
                Inspired by curiosity about machine learning, I built a handwritten digit recognition model 
                using Python and TensorFlow. The project introduced me to data handling, training workflows,
                 and understanding how models learn from patterns.
              </p>

              <p className="tp-tools">
                Progams used: Python, Tensorflow, Git + GitHub, Numpy, Matplotlib
              </p>

              <Link to="/projects/tensor" className="tp-link"> Learn more →</Link>
            </article>
          </div>
        </section>

         {/* 5 */}
        <section className="tp-section tp-section--light">
          <div className="tp-row">
            <figure className="tp-thumb reveal">
               <img src={Portfolio_Thumb} alt="My Portfolio" className="fade-up" />
            </figure>

            <article className="tp-card reveal">
              <div className="tp-card-head">
                <h2 className="tp-card-title">My Portfolio</h2>
                <time className="tp-card-date">2025</time>
              </div>

              <p className="tp-card-desc">
                Instead of relying on boring resumes and other pre-made portfolio, I decided to program my protfolio from the ground up.
                I made my website to highlight my art, projects, and experience through clean visuals and structure. 
                Every part of the site reflects my approach to design, development, and storytelling.
              </p>

              <p className="tp-tools">
                Programs used: Procreate, Adobe Photoshop + Illustrator, Figma, Javascript, React.JS, HTML/CSS, Git + GitHub
              </p>

              <Link to="/projects/portfolio" className="tp-link"> Learn more →</Link>
            </article>
          </div>
        </section>

        

        
      </main>
    </Layout>
  );
}
